<template>
  <div>
    <el-dialog :title="this.value.isCreate ? '添加模板' : '修改模板'" center :visible.sync="visible" @closed="onClosed"
      :close-on-click-modal="false" :close-on-press-escape="false" width="750px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="mini">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="（仅为了方便在后台页面上区分不同模板，不会在游戏里展示）" style="width: 500px"></el-input>
        </el-form-item>
        <el-form-item>
          <div>
            <MailTemplate ref="mailTemplate" :languageTemplates="form.languageTemplates" style="width: 500px"></MailTemplate>
          </div>
        </el-form-item>
        <el-form-item v-if="!this.value.isCreate">
          <div style="color: red;">注意：修改模板会导致已发出的邮件的内容也受到影响，请谨慎使用！</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import MailTemplate from "@/pages/mail/components/MailTemplate";

export default {
  data() {
    return {
      visible: true,
      form: {
        name: "",
        languageTemplates: [],
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  async created() {
    if (!this.value.isCreate) {
      this.form.name = this.value.templateData.templateName;
      this.form.languageTemplates = this.value.templateData.languageTemplates;
    }
  },

  components: {
    MailTemplate,
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          return false;
        }

        // 取得邮件模板
        let mailTemplate = {};
        {
          let getDataResult = this.$refs.mailTemplate.getData();
          if (getDataResult.errorMessage) {
            this.$message({
              message: getDataResult.errorMessage,
              type: "error",
            });
            return;
          }

          mailTemplate = {
            languageTemplates: getDataResult.data.languageTemplates,
          }
        }

        let apiUrl = "";
        let requestBody = null;
        if (this.value.isCreate) {
          apiUrl = `${util.getBackendApiBase()}/v1/admin/addMailTemplate`;
          requestBody = {
            mailTemplateName: this.form.name,
            mailTemplate: mailTemplate.languageTemplates,
          };
        } else {
          apiUrl = `${util.getBackendApiBase()}/v1/admin/updateMailTemplate`;
          requestBody = {
            mailTemplateId: this.value.templateData.templateId,
            mailTemplateName: this.form.name,
            mailTemplate: mailTemplate.languageTemplates,
          };
        }

        let resData = (
          await axios.post(apiUrl, requestBody, {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          })
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },

    /**
     * 为各个语言构建空模板
     */
    async buildEmptyTemplatesForAllLanguages(languages) {
      for (let l of languages) {
        this.form.languageTemplates.push({
          language: l,
          title: "",
          content: "",
        });
      }

      if (
        this.form.languageTemplates &&
        this.form.languageTemplates.length > 0
      ) {
        this.form.activeLanguageTabName =
          this.form.languageTemplates[0].language;
      }
    },
  },
};
</script>